import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Icon, Slider } from 'antd';

import './KmAvgFilter.css';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class KmAvgFilter extends Component {
  keyStorage = `carFilter_avgKm`;

  constructor(props) {
    super(props);

    let defaultState = {
      visible: false,
      minKmAvg: 0,
      maxKmAvg: 0,
      selectedMinKmAvg: null,
      selectedMaxKmAvg: null,
      avgKm: []
    };
    const { filterStore } = this.props;
    let { selectedMinKmAvg, selectedMaxKmAvg } = filterStore.appliedFiltersParameters[this.keyStorage] || {};
    if (selectedMinKmAvg !== undefined && selectedMaxKmAvg !== undefined) {
      const avgKm = [selectedMinKmAvg, selectedMaxKmAvg];
      defaultState = { ...defaultState, avgKm, selectedMinKmAvg, selectedMaxKmAvg };
    }
    this.state = defaultState;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  changeAvgKm = avgKm => {
    this.setState({ avgKm: [avgKm[0] || this.props.carsStore.minKmAvg, avgKm[1] || this.props.carsStore.minKmAvg] }, () => {
      this.setState({ selectedMinKmAvg: this.state.avgKm[0], selectedMaxKmAvg: this.state.avgKm[1] });
    });
  };

  changeFilter = avgKm => {
    const { filterStore } = this.props;
    if (avgKm) {
      filterStore.add('carFilter_avgKm', car => car.kmPerDay >= avgKm[0] && car.kmPerDay <= avgKm[1], undefined, {
        selectedMinKmAvg: avgKm[0],
        selectedMaxKmAvg: avgKm[1]
      });
    } else {
      filterStore.remove('carFilter_avgKm');
    }
  };

  removeAvgKm = () => {
    const { filterStore } = this.props;
    this.setState({ selectedMinKmAvg: null, selectedMaxKmAvg: null, avgKm: undefined });
    filterStore.remove('carFilter_avgKm');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        minKmAvg: 0,
        maxKmAvg: 0,
        selectedMinKmAvg: null,
        selectedMaxKmAvg: null,
        avgKm: []
      });
    }
  };

  render() {
    const { selectedMinKmAvg, selectedMaxKmAvg, avgKm } = this.state;
    const { translationsStore, carsStore } = this.props;

    return (
      <div id="kmAvgFilter" className="KmAvgFilter">
        <span className="filterTitle">
          {translationsStore.translate('carList.filters.filter.kmAvg')}
          {Number.isInteger(selectedMinKmAvg) && (
            <span>
              {selectedMinKmAvg} - {selectedMaxKmAvg}
              <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeAvgKm} />
            </span>
          )}
        </span>
        <Slider
          disabled={carsStore.minKmAvg === carsStore.maxKmAvg}
          value={avgKm || [carsStore.minKmAvg, carsStore.maxKmAvg]}
          onChange={this.changeAvgKm}
          onBeforeChange={this.changeFilter} //https://github.com/react-component/slider/issues/529 -> when the bug get close we have to use onAfterChange. onBeforeChange is not documented in antd Slider
          onAfterChange={this.changeFilter} //https://github.com/react-component/slider/issues/529 -> when the bug get close we have to use onAfterChange. onBeforeChange is not documented in antd Slider
          tipFormatter={null}
          step={10}
          range
          min={carsStore.minKmAvg}
          max={carsStore.maxKmAvg}
          marks={{
            [carsStore.minKmAvg]: {
              style: {
                color: '#f50'
              },
              label: `${carsStore.minKmAvg} Km`
            },
            [carsStore.maxKmAvg]: {
              style: {
                color: '#f50'
              },
              label: (
                <div>
                  <span>{carsStore.maxKmAvg}</span>
                  <span>&nbsp;km</span>
                </div>
              )
            }
          }}
        />
      </div>
    );
  }
}
